import { put, select, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import { v4 as uuidv4 } from 'uuid';

import { accountOrganizationsWithDistrictGet } from 'CorePackage/AccountModule/actions/accountActions';
import {
  dictionariesDangerClassesItemGet,
  dictionariesDecisionKindsItemGet,
  dictionariesEventHasUnplannedActivityGet,
  dictionariesEventTypesItemGet,
  dictionariesEventUuidGet,
  dictionariesItemValueGetSuccess,
  dictionariesKnoSupervisionGet,
  dictionariesParticipantPositionsItemGet,
  dictionariesPositionsItemGet,
  dictionariesRiskCategoriesItemGet,
  dictionariesSubjectKindsItemGet,
  dictionariesSubjectSubKindsItemGet,
  dictionariesSubjectTypesItemGet,
  dictionariesSupervisionTypesItemGet,
  dictionariesTargetEntityItemGet,
} from 'CorePackage/DictionariesModule/actions/dictionariesActions';
import { getDictionarySelectOptionWithState } from 'CorePackage/DictionariesModule/common/getDictionarySelectOptionWithState';
import { DictionariesActionsEnum } from 'CorePackage/DictionariesModule/enums/DictionariesActionsEnum';
import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getInitialObject } from 'KnmErknmPackage/MainModule/common/getInitialObject';
import { IKnmErknmFormInspector } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormInspector';
import { IKnmErknmFormObject } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';
import { InspectionResultFieldEnum } from 'APIPackage/CatalogsModule/enums/InspectionResultFieldEnum';
import { catalogErknmDecisionConditionsGet } from 'CorePackage/CatalogsModule/actions/catalogsActions';
import { IKnmActSingerSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmActSingerSelectOption';
import { getSelectOption } from 'KnmErknmPackage/MainModule/common/getSelectOption';

import { decisionSetInitialFormValues } from '../actions/decisionActions';
import { DecisionActionsEnum } from '../enums/DecisionActionsEnum';
import { IDecisionOrganizationForm } from '../interfaces/IDecisionOrganizationForm';
import {
  getDecisionData,
  getDecisionEventUuid,
  getDecisionInitialFormValues,
  getDecisionKindDictVersionIdFormValue,
  getDecisionKnoOrganizationFormValue,
  getDecisionKnoSupervisionUuid,
  getDecisionReasonsFormValue,
  getDecisionSupervisionTypeFormValue,
} from '../selectors/decisionSelectors';
import { convertDecisionDataJudgmentsToFormValues } from '../../DecisionJudgmentModule/common/convertDecisionDataJudgmentsToFormValues';
import { IDecisionResultDecisionForm } from '../interfaces/IDecisionResultDecisionForm';
import { getKindControlLabel } from '../../../KnmPackage/MainModule/common/getKindControlLabel';
import { getKindControlSelectedLabel } from '../../../KnmPackage/MainModule/common/getKindControlSelectedLabel';
import { isLaterThanAdminSetting } from '../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { getAdminFetchSettings } from '../../../PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IKnmErknmFormEvent } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEvent';
import { createSubmittedDocuments } from '../../../KnmPackage/MainModule/common/createSubmittedDocuments';
import { FEDERAL_LOW_248_GUID } from '../../../KnmPackage/MainModule/constants/erknmFederalLawUuid';

export function* watchDecisionDictionariesSaga() {
  yield takeEvery(
    [
      DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_SUCCESS,
      DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_ALREADY_LOAD,
    ],
    decisionSetValueByOptionsSaga,
  );
  yield takeEvery(
    [
      DecisionActionsEnum.DECISION_SET_KNO_ORGANIZATION_FORM_VALUE,
      DecisionActionsEnum.DECISION_SET_SUPERVISION_TYPE_FORM_VALUE,
    ],
    initDictionaryKnmKindsSaga,
  );
  yield takeEvery(
    [
      DecisionActionsEnum.DECISION_SET_KNO_ORGANIZATION_FORM_VALUE,
      DecisionActionsEnum.DECISION_SET_SUPERVISION_TYPE_FORM_VALUE,
      DecisionActionsEnum.DECISION_SET_REASONS_FORM_VALUE,
    ],
    initDictionariesTargetEntity,
  );
  yield takeEvery(DecisionActionsEnum.DECISION_SET_KNO_ORGANIZATION_FORM_VALUE, initDictionaryKnmSupervisionTypesSaga);
  yield takeEvery(DecisionActionsEnum.DECISION_CATALOGS_INIT, initAccountOrganizationsWithDistrictSaga);
  yield takeEvery(
    [
      DecisionActionsEnum.DECISION_SET_KNO_ORGANIZATION_FORM_VALUE,
      DecisionActionsEnum.DECISION_SET_SUPERVISION_TYPE_FORM_VALUE,
      DecisionActionsEnum.DECISION_SET_KIND_VERSION_ID_FORM_VALUE,
    ],
    initDictionariesEventUuidSaga,
  );
  yield takeEvery(
    [
      DecisionActionsEnum.DECISION_SET_KNO_ORGANIZATION_FORM_VALUE,
      DecisionActionsEnum.DECISION_SET_SUPERVISION_TYPE_FORM_VALUE,
      DecisionActionsEnum.DECISION_SET_KIND_VERSION_ID_FORM_VALUE,
    ],
    initDictionariesEventHasUnplannedActivitySaga,
  );
  yield takeEvery(
    [
      DecisionActionsEnum.DECISION_SET_KNO_ORGANIZATION_FORM_VALUE,
      DecisionActionsEnum.DECISION_SET_SUPERVISION_TYPE_FORM_VALUE,
    ],
    initDictionariesKnoSupervisionSaga,
  );

  yield takeEvery([DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS], initDictionariesPositions);

  yield takeEvery(
    [DictionariesActionsEnum.DICTIONARIES_EVENT_UUID_GET_SUCCESS, DecisionActionsEnum.DECISION_SET_REASONS_FORM_VALUE],
    initDictionariesRiskCategories,
  );
  yield takeEvery(
    [
      DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS,
      DecisionActionsEnum.DECISION_SET_REASONS_FORM_VALUE,
    ],
    initDictionariesDangerClassesSaga,
  );
  yield takeEvery(
    [
      DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS,
      DecisionActionsEnum.DECISION_SET_REASONS_FORM_VALUE,
    ],
    initDictionariesSubjectTypesSaga,
  );
  yield takeEvery(
    [
      DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS,
      DecisionActionsEnum.DECISION_SET_REASONS_FORM_VALUE,
    ],
    initDictionariesSubjectKindsSaga,
  );
  yield takeEvery(
    [
      DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS,
      DecisionActionsEnum.DECISION_SET_REASONS_FORM_VALUE,
    ],
    initDictionariesSubjectSubKindsSaga,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET_SUCCESS,
    initDictionariesParticipantPositions,
  );
  yield takeEvery(
    [DictionariesActionsEnum.DICTIONARIES_EVENT_UUID_GET_SUCCESS, DecisionActionsEnum.DECISION_SET_REASONS_FORM_VALUE],
    initDictionaryEventTypesSaga,
  );
  yield takeEvery(
    [
      DecisionActionsEnum.DECISION_SET_KNO_ORGANIZATION_FORM_VALUE,
      DecisionActionsEnum.DECISION_SET_SUPERVISION_TYPE_FORM_VALUE,
      DecisionActionsEnum.DECISION_SET_KIND_VERSION_ID_FORM_VALUE,
    ],
    initCatalogErknmDecisionConditionsSaga,
  );
}

function* initDictionariesPositions() {
  const state: IRootState = yield select();
  const knoSupervisionUuid = getDecisionKnoSupervisionUuid(state);

  if (knoSupervisionUuid) {
    yield put(dictionariesPositionsItemGet(knoSupervisionUuid));
  }
}

function* initDictionariesKnoSupervisionSaga() {
  const state: IRootState = yield select();
  const knoOrganizationDictVersionId = getDecisionKnoOrganizationFormValue(state)?.value.dictVersionId;
  const supervisionTypeDictVersionId = getDecisionSupervisionTypeFormValue(state)?.value.dictVersionId;

  if (knoOrganizationDictVersionId && supervisionTypeDictVersionId) {
    yield put(dictionariesKnoSupervisionGet(knoOrganizationDictVersionId, supervisionTypeDictVersionId));
  }
}

function* initDictionariesEventUuidSaga() {
  const state: IRootState = yield select();
  const knoOrganizationDictVersionId = getDecisionKnoOrganizationFormValue(state)?.value.dictVersionId;
  const supervisionTypeDictVersionId = getDecisionSupervisionTypeFormValue(state)?.value.dictVersionId;
  const kindDictVersionId = getDecisionKindDictVersionIdFormValue(state);

  if (knoOrganizationDictVersionId && supervisionTypeDictVersionId && kindDictVersionId) {
    yield put(dictionariesEventUuidGet(knoOrganizationDictVersionId, supervisionTypeDictVersionId, kindDictVersionId));
  }
}

function* initDictionariesEventHasUnplannedActivitySaga() {
  const state: IRootState = yield select();
  const knoOrganizationDictVersionId = getDecisionKnoOrganizationFormValue(state)?.value.dictVersionId;
  const supervisionTypeDictVersionId = getDecisionSupervisionTypeFormValue(state)?.value.dictVersionId;
  const kindDictVersionId = getDecisionKindDictVersionIdFormValue(state);

  if (knoOrganizationDictVersionId && supervisionTypeDictVersionId && kindDictVersionId) {
    yield put(
      dictionariesEventHasUnplannedActivityGet(
        knoOrganizationDictVersionId,
        supervisionTypeDictVersionId,
        kindDictVersionId,
      ),
    );
  }
}

function* initCatalogErknmDecisionConditionsSaga() {
  const state: IRootState = yield select();
  const initialFormValues = getDecisionInitialFormValues(state);
  const knoOrganizationDictVersionId = getDecisionKnoOrganizationFormValue(state)?.value.dictVersionId;
  const supervisionTypeDictVersionId = getDecisionSupervisionTypeFormValue(state)?.value.dictVersionId;
  const kindDictVersionId = getDecisionKindDictVersionIdFormValue(state);
  const settings = getAdminFetchSettings(state);
  const isDecisionReasonValidate = isLaterThanAdminSetting(
    initialFormValues?.created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_523_4_1_53_STARTS_FROM,
  );

  if (isDecisionReasonValidate && knoOrganizationDictVersionId && supervisionTypeDictVersionId && kindDictVersionId) {
    yield put(
      catalogErknmDecisionConditionsGet(knoOrganizationDictVersionId, supervisionTypeDictVersionId, kindDictVersionId),
    );
  }
}

function* decisionSetValueByOptionsSaga(action: ActionType<typeof dictionariesItemValueGetSuccess>) {
  const { dictionaryUUID, dictionaryVersionUUID } = action.payload;
  const state: IRootState = yield select();
  const data = getDecisionData(state);
  const initialFormValues = getDecisionInitialFormValues(state);
  const settings = getAdminFetchSettings(state);

  switch (dictionaryUUID) {
    case DictionaryUUIDsEnum.KNO_ORGANIZATIONS: {
      const knmDataKnoOrganizationErknm = data?.knoOrganization;

      if (dictionaryVersionUUID === knmDataKnoOrganizationErknm?.dictVersionId) {
        const selectOption = getDictionarySelectOptionWithState<typeof dictionaryUUID>(
          state,
          dictionaryUUID,
          dictionaryVersionUUID,
        );

        yield put(decisionSetInitialFormValues({ knoOrganization: selectOption }));
      }
      break;
    }
    case DictionaryUUIDsEnum.DECISION_KIND: {
      const selectOption = getDictionarySelectOptionWithState<typeof dictionaryUUID>(
        state,
        dictionaryUUID,
        dictionaryVersionUUID,
      );

      if (dictionaryVersionUUID === data?.kind?.dictVersionId) {
        yield put(
          decisionSetInitialFormValues({
            kind: selectOption,
          }),
        );
      }
      break;
    }
    case DictionaryUUIDsEnum.SUBJECT_TYPE: {
      yield put(
        decisionSetInitialFormValues({
          objects: data?.objects?.map((object, index) => {
            const selectOption = object.objectType?.dictId
              ? getDictionarySelectOptionWithState<typeof dictionaryUUID>(
                  state,
                  object.objectType?.dictId,
                  object.objectType?.dictVersionId,
                )
              : undefined;

            const initialObject: IKnmErknmFormObject | undefined = initialFormValues.objects?.[index];

            return {
              ...getInitialObject(initialObject),
              objectType: selectOption,
            };
          }),
        }),
      );
      break;
    }
    case DictionaryUUIDsEnum.SUBJECT_KIND: {
      yield put(
        decisionSetInitialFormValues({
          objects: data?.objects?.map((object, index) => {
            const objectKindSelectOption = object.objectKind?.dictId
              ? getDictionarySelectOptionWithState<typeof dictionaryUUID>(
                  state,
                  object.objectKind?.dictId,
                  object.objectKind?.dictVersionId,
                )
              : undefined;
            const objectSubKindSelectOption = object.objectSubKind?.dictId
              ? getDictionarySelectOptionWithState<typeof dictionaryUUID>(
                  state,
                  object.objectSubKind?.dictId,
                  object.objectSubKind?.dictVersionId,
                )
              : undefined;
            const initialObject: IKnmErknmFormObject | undefined = initialFormValues.objects?.[index];

            return {
              ...getInitialObject(initialObject),
              objectKind: objectKindSelectOption,
              objectSubKind: objectSubKindSelectOption,
            };
          }),
        }),
      );
      break;
    }
    case DictionaryUUIDsEnum.SUBJECT_SUB_KIND: {
      yield put(
        decisionSetInitialFormValues({
          objects: data?.objects?.map((object, index) => {
            const objectKindSelectOption = object.objectKind?.dictId
              ? getDictionarySelectOptionWithState<typeof dictionaryUUID>(
                  state,
                  object.objectKind?.dictId,
                  object.objectKind?.dictVersionId,
                )
              : undefined;
            const objectSubKindSelectOption = object.objectSubKind?.dictId
              ? getDictionarySelectOptionWithState<typeof dictionaryUUID>(
                  state,
                  object.objectSubKind?.dictId,
                  object.objectSubKind?.dictVersionId,
                )
              : undefined;

            const objectTypeSelectOption = object.objectType?.dictId
              ? getDictionarySelectOptionWithState<typeof dictionaryUUID>(
                  state,
                  object.objectType?.dictId,
                  object.objectType?.dictVersionId,
                )
              : undefined;

            const initialObject: IKnmErknmFormObject | undefined = initialFormValues.objects?.[index];

            return {
              ...getInitialObject(initialObject),
              objectKind: objectKindSelectOption,
              objectSubKind: objectSubKindSelectOption,
              objectType: objectTypeSelectOption || initialObject?.objectType,
            };
          }),
        }),
      );
      break;
    }
    case DictionaryUUIDsEnum.RISK_CATEGORY: {
      yield put(
        decisionSetInitialFormValues({
          objects: data?.objects?.map((object, index) => {
            const initialObject: IKnmErknmFormObject | undefined = initialFormValues.objects?.[index];
            const inspectionResults = object.inspectionResults || [];
            const parentInspectionResultRisk = inspectionResults.find(
              i => i.inspectedField === InspectionResultFieldEnum.RISK_CATEGORY,
            );
            const parentInspectionResultDanger = inspectionResults.find(
              i => i.inspectedField === InspectionResultFieldEnum.DANGER_CLASS,
            );
            const riskCategorySelectOption = object.riskCategory?.dictId
              ? getDictionarySelectOptionWithState<typeof dictionaryUUID>(
                  state,
                  object.riskCategory?.dictId,
                  object.riskCategory?.dictVersionId,
                )
              : undefined;
            const dangerClassSelectOption = object.dangerClass?.dictId
              ? getDictionarySelectOptionWithState<typeof DictionaryUUIDsEnum.DANGER_CLASS>(
                  state,
                  object.dangerClass?.dictId,
                  object.dangerClass?.dictVersionId,
                )
              : undefined;

            return {
              ...getInitialObject(initialObject),
              riskCategory: riskCategorySelectOption && {
                ...riskCategorySelectOption,
                inspectionResult: object.riskCategory?.inspectionResult || parentInspectionResultRisk,
              },
              dangerClass: dangerClassSelectOption && {
                ...dangerClassSelectOption,
                inspectionResult: object.dangerClass?.inspectionResult || parentInspectionResultDanger,
              },
            };
          }),
        }),
      );
      break;
    }
    case DictionaryUUIDsEnum.DANGER_CLASS: {
      yield put(
        decisionSetInitialFormValues({
          objects: data?.objects?.map((object, index) => {
            const selectOption = object.dangerClass?.dictId
              ? getDictionarySelectOptionWithState<typeof dictionaryUUID>(
                  state,
                  object.dangerClass?.dictId,
                  object.dangerClass?.dictVersionId,
                )
              : undefined;
            const initialObject: IKnmErknmFormObject | undefined = initialFormValues.objects?.[index];
            const inspectionResults = object.inspectionResults || [];
            const parentInspectionResultDanger = inspectionResults.find(
              i => i.inspectedField === InspectionResultFieldEnum.DANGER_CLASS,
            );

            return {
              ...getInitialObject(initialObject),
              dangerClass: selectOption && {
                ...selectOption,
                inspectionResult: object.dangerClass?.inspectionResult || parentInspectionResultDanger,
              },
            };
          }),
        }),
      );
      break;
    }
    case DictionaryUUIDsEnum.EVENT_TYPE: {
      const initialEvents = data?.events;
      const decisionEvents = initialEvents?.map((item, index) => {
        const selectOption = item.event?.dictId
          ? getDictionarySelectOptionWithState<typeof dictionaryUUID>(
              state,
              item.event?.dictId,
              item.event?.dictVersionId,
            )
          : undefined;

        const formEvent: IKnmErknmFormEvent = {
          guid: undefined,
          startDate: undefined,
          stopDate: undefined,
          dateCreate: undefined,
          interactionCategory: undefined,
          listId: item?.guid || uuidv4(),
          ...initialFormValues.events?.[index],
          type: selectOption,
          isNew: !!item?.isNew,
          submittedDocuments: createSubmittedDocuments(item.submittedDocuments),
        };

        return formEvent;
      });

      yield put(
        decisionSetInitialFormValues({
          events: decisionEvents,
        }),
      );
      break;
    }
    case DictionaryUUIDsEnum.SUPERVISION_TYPE: {
      const selectOption = getDictionarySelectOptionWithState<typeof dictionaryUUID>(
        state,
        dictionaryUUID,
        dictionaryVersionUUID,
      );

      if (dictionaryVersionUUID === data?.kindControl?.dictVersionId) {
        const isUseTransferringAuthorities = isLaterThanAdminSetting(
          initialFormValues.created,
          settings,
          AdminSettingCodesEnum.TRANSFERRING_AUTHORITIES_4_1_22_STARTS_FROM,
        );

        yield put(
          decisionSetInitialFormValues({
            kindControl: selectOption
              ? {
                  ...selectOption,
                  label:
                    getKindControlSelectedLabel(selectOption, isUseTransferringAuthorities) ||
                    getKindControlLabel(selectOption, isUseTransferringAuthorities),
                  selectedLabel: getKindControlSelectedLabel(selectOption, isUseTransferringAuthorities),
                }
              : undefined,
          }),
        );
      }
      break;
    }
    case DictionaryUUIDsEnum.PARTICIPANT_POSITIONS: {
      yield put(
        decisionSetInitialFormValues({
          inspectors: data?.inspectors?.map(item => {
            const selectOption = item.position?.dictId
              ? getDictionarySelectOptionWithState<typeof dictionaryUUID>(
                  state,
                  item.position?.dictId,
                  item.position?.dictVersionId,
                )
              : undefined;
            const inspectorGuid = item.guid || uuidv4();
            const formInspector: IKnmErknmFormInspector = {
              ...item,
              position: selectOption,
              guid: inspectorGuid,
              listId: inspectorGuid,
            };

            return formInspector;
          }),
        }),
      );
      const inspectors = data?.organization?.act?.knoInspectors?.map(inspector => {
        const selectOption = inspector.position?.dictId
          ? getDictionarySelectOptionWithState<typeof DictionaryUUIDsEnum.PARTICIPANT_POSITIONS>(
              state,
              inspector.position?.dictId,
              inspector.position?.dictVersionId,
            )
          : undefined;
        const formInspector: IKnmErknmFormInspector = {
          ...inspector,
          position: selectOption,
          listId: inspector.guid || uuidv4(),
          label: `${inspector.fullName} - ${selectOption?.label}`,
        };

        return formInspector;
      });
      let fioAndPositionSinger: IKnmActSingerSelectOption | undefined;
      const titleSignerSelectOption = data?.organization?.act?.titleSigner?.dictId
        ? getSelectOption<DictionaryUUIDsEnum.PARTICIPANT_POSITIONS>(
            state,
            data?.organization?.act?.titleSigner?.dictId,
            data?.organization?.act?.titleSigner?.dictVersionId,
          )
        : undefined;

      if (data?.organization?.act?.fioSigner && titleSignerSelectOption) {
        fioAndPositionSinger = {
          id: '',
          label: `${data?.organization?.act?.fioSigner} - ${titleSignerSelectOption?.label}`,
          value: {
            dateCreate: null,
            fullName: data?.organization?.act?.fioSigner,
            guid: undefined,
            listId: '',
            position: titleSignerSelectOption,
            label: '',
          },
        };

        if (inspectors) {
          const singer = inspectors?.find(
            i =>
              i.fullName === data?.organization?.act?.fioSigner &&
              i.position?.value.dictId === data?.organization?.act?.titleSigner?.dictId,
          );

          if (singer) {
            fioAndPositionSinger = {
              id: singer?.guid || '',
              label: `${singer.fullName} - ${singer.position?.label}`,
              value: singer,
            };
          }
        }
      }
      const organizationValue: IDecisionOrganizationForm | undefined = data?.organization
        ? {
            ...(initialFormValues.organization as IDecisionOrganizationForm),
            resultDecisions: data?.organization?.decisions?.map((decision, index) => {
              const decisionNew: IDecisionResultDecisionForm = {
                ...initialFormValues.organization?.resultDecisions?.[index],
                titleSigner: decision.titleSigner?.dictId
                  ? getDictionarySelectOptionWithState<DictionaryUUIDsEnum.PARTICIPANT_POSITIONS>(
                      state,
                      decision.titleSigner.dictId,
                      decision.titleSigner?.dictVersionId,
                    )
                  : undefined,
                systemSignatureUsed: decision.systemSignatureUsed || false,
                systemSignatureMnemonic: decision.systemSignatureMnemonic || null,
                systemSignatureTitle: decision.systemSignatureTitle || null,
                systemSignatureDateTime: decision.systemSignatureDateTime || null,
                cancelTitleSigner: decision.cancelTitleSigner?.dictId
                  ? getDictionarySelectOptionWithState<DictionaryUUIDsEnum.POSITIONS>(
                      state,
                      decision.cancelTitleSigner.dictId,
                      decision.cancelTitleSigner?.dictVersionId,
                    )
                  : undefined,
              };

              return decisionNew;
            }),
            act: !initialFormValues?.organization?.act
              ? undefined
              : {
                  ...initialFormValues?.organization?.act,
                  fioAndPositionSinger,
                  knoInspectors: inspectors?.map(i => {
                    const inspectorGuid = i.guid || uuidv4();

                    return {
                      listId: inspectorGuid,
                      guid: inspectorGuid,
                      knoInspector: {
                        id: inspectorGuid,
                        label: `${i.fullName} - ${i.position?.label}`,
                        value: i,
                      },
                      fullName: undefined,
                      position: undefined,
                      dateCreate: i.dateCreate || undefined,
                    };
                  }),
                },
          }
        : undefined;

      yield put(
        decisionSetInitialFormValues({
          organization: organizationValue,
          judgments: data?.judgments
            ? convertDecisionDataJudgmentsToFormValues(state, data?.judgments, organizationValue)
            : undefined,
        }),
      );
      break;
    }
    default:
  }
}

function* initAccountOrganizationsWithDistrictSaga() {
  yield put(accountOrganizationsWithDistrictGet());
}

function* initDictionaryKnmKindsSaga() {
  const state: IRootState = yield select();
  const knoOrganizationDictVersionId = getDecisionKnoOrganizationFormValue(state)?.value.dictVersionId;
  const supervisionTypeDictVersionId = getDecisionSupervisionTypeFormValue(state)?.value.dictVersionId;

  if (knoOrganizationDictVersionId && supervisionTypeDictVersionId) {
    yield put(
      dictionariesDecisionKindsItemGet({
        knoVersionId: knoOrganizationDictVersionId,
        supervisionVersionId: supervisionTypeDictVersionId,
      }),
    );
  }
}

function* initDictionaryKnmSupervisionTypesSaga() {
  const state: IRootState = yield select();
  const knoOrganizationDictVersionId = getDecisionKnoOrganizationFormValue(state)?.value.dictVersionId;

  if (knoOrganizationDictVersionId) {
    yield put(dictionariesSupervisionTypesItemGet([knoOrganizationDictVersionId], false, [FEDERAL_LOW_248_GUID]));
  }
}

function* initDictionariesTargetEntity() {
  const state: IRootState = yield select();
  const knoVersionId = getDecisionKnoOrganizationFormValue(state)?.value?.dictVersionId;
  const supervisionVersionId = getDecisionSupervisionTypeFormValue(state)?.value?.dictVersionId;
  const reasons = getDecisionReasonsFormValue(state);
  const reasonUuid = reasons?.map(x => x?.ervkUuid)?.find(uuid => uuid);
  const orderVersionUuid = reasons?.map(x => x?.order?.recordVersionId)?.find(uuid => uuid);

  if (knoVersionId && supervisionVersionId && (reasonUuid || orderVersionUuid)) {
    yield put(
      dictionariesTargetEntityItemGet({
        knoVersionId,
        supervisionVersionId,
        conditionUuid: reasonUuid,
        orderVersionId: orderVersionUuid,
      }),
    );
  }
}

function* initDictionariesRiskCategories() {
  const state: IRootState = yield select();
  const knoSupervisionUuid = getDecisionKnoSupervisionUuid(state);
  const reasons = getDecisionReasonsFormValue(state);
  const reasonUuid = reasons?.map(x => x?.ervkUuid)?.find(uuid => uuid);
  const orderVersionUuid = reasons?.map(x => x?.order?.recordVersionId)?.find(uuid => uuid);

  if (knoSupervisionUuid && (reasonUuid || orderVersionUuid)) {
    yield put(dictionariesRiskCategoriesItemGet(knoSupervisionUuid, reasonUuid, orderVersionUuid, undefined));
  }
}

function* initDictionariesDangerClassesSaga() {
  const state: IRootState = yield select();
  const knoSupervisionUuid = getDecisionKnoSupervisionUuid(state);
  const reasons = getDecisionReasonsFormValue(state);
  const reasonUuid = reasons?.map(x => x?.ervkUuid)?.find(uuid => uuid);
  const orderVersionUuid = reasons?.map(x => x?.order?.recordVersionId)?.find(uuid => uuid);

  if (knoSupervisionUuid) {
    yield put(dictionariesDangerClassesItemGet(knoSupervisionUuid, reasonUuid, orderVersionUuid, undefined));
  }
}

function* initDictionariesSubjectTypesSaga() {
  const state: IRootState = yield select();
  const knoSupervisionUuid = getDecisionKnoSupervisionUuid(state);
  const reasons = getDecisionReasonsFormValue(state);
  const reasonUuid = reasons?.map(x => x?.ervkUuid)?.find(uuid => uuid);
  const orderVersionUuid = reasons?.map(x => x?.order?.recordVersionId)?.find(uuid => uuid);

  if (knoSupervisionUuid && (reasonUuid || orderVersionUuid)) {
    yield put(dictionariesSubjectTypesItemGet(knoSupervisionUuid, reasonUuid, orderVersionUuid));
  }
}

function* initDictionariesSubjectKindsSaga() {
  const state: IRootState = yield select();
  const knoSupervisionUuid = getDecisionKnoSupervisionUuid(state);
  const reasons = getDecisionReasonsFormValue(state);
  const reasonUuid = reasons?.map(x => x?.ervkUuid)?.find(uuid => uuid);
  const orderVersionUuid = reasons?.map(x => x?.order?.recordVersionId)?.find(uuid => uuid);

  if (knoSupervisionUuid && (reasonUuid || orderVersionUuid)) {
    yield put(dictionariesSubjectKindsItemGet(knoSupervisionUuid, reasonUuid, orderVersionUuid));
  }
}

function* initDictionariesSubjectSubKindsSaga() {
  const state: IRootState = yield select();
  const knoSupervisionUuid = getDecisionKnoSupervisionUuid(state);
  const reasons = getDecisionReasonsFormValue(state);
  const reasonUuid = reasons?.map(x => x?.ervkUuid)?.find(uuid => uuid);
  const orderVersionUuid = reasons?.map(x => x?.order?.recordVersionId)?.find(uuid => uuid);

  if (knoSupervisionUuid && (reasonUuid || orderVersionUuid)) {
    yield put(dictionariesSubjectSubKindsItemGet(knoSupervisionUuid, reasonUuid, orderVersionUuid));
  }
}

function* initDictionariesParticipantPositions() {
  const state: IRootState = yield select();
  const knoSupervisionUuid = getDecisionKnoSupervisionUuid(state);

  if (knoSupervisionUuid) {
    yield put(dictionariesParticipantPositionsItemGet(knoSupervisionUuid));
  }
}

function* initDictionaryEventTypesSaga() {
  const state: IRootState = yield select();
  const eventUuid = getDecisionEventUuid(state)?.find(x => x);
  const reasons = getDecisionReasonsFormValue(state);
  const reasonUuid = reasons?.map(x => x?.ervkUuid)?.find(uuid => uuid);
  const orderVersionUuid = reasons?.map(x => x?.order?.recordVersionId)?.find(uuid => uuid);

  if (eventUuid && (orderVersionUuid || reasonUuid)) {
    yield put(dictionariesEventTypesItemGet(false, eventUuid, reasonUuid, orderVersionUuid));
  }
}
